module.exports = __webpack_public_path__ + "img/adel.679946fa.png";